import { render } from "./board.vue?vue&type=template&id=50f80cad&ts=true"
import script from "./board.vue?vue&type=script&lang=ts&config=true"
export * from "./board.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__